export function loadState() {
  try {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("reduxState_")
    );

    const state = {};
    keys.forEach((key) => {
      const serializedState = localStorage.getItem(key);
      const sliceName = key.replace("reduxState_", "");
      if (serializedState !== null) {
        state[sliceName] = JSON.parse(serializedState);
      }
    });
    return state;
  } catch (err) {
    return undefined;
  }
}
